import react, {useEffect} from 'react'
import {Sidebar} from 'elements/sidebar';
import {Puff} from 'react-loader-spinner'
import styled from "styled-components";
import {useAuth} from "hooks/useAuth";
import {useStores} from "stores/root";
import {observer} from "mobx-react-lite";


const CenterContainer = styled.div`
  display: flex;
  width: 95vw;
  height: 95vh;
  justify-content: center;
  align-items: center;
`

export const MainPage: react.FC<{ children: react.ReactNode }> = observer(({children}) => {
    let {authenticated} = useAuth();
    const {onboarding} = useStores();

    useEffect(() => {
        if (!authenticated) return;
        onboarding.startOnboarding();
    }, [authenticated]);

    var pathname = window.location.pathname.split('/');
    var lastpath = pathname[pathname.length - 1];
    if (lastpath === 'main' || lastpath.length === 0) {
        window.location.replace('/main/scan')
    }
    if (lastpath === 'docs') {
        window.open('https://docs.its-ai.org')
    }
    if (!authenticated) {
        return <CenterContainer><Puff width="200" color="grey"/></CenterContainer>
    }
    return <>
        <Sidebar/>
        {children}
    </>
})